import { render, staticRenderFns } from "./TableInfoMonthly.vue?vue&type=template&id=381e1d6f&scoped=true&"
import script from "./TableInfoMonthly.vue?vue&type=script&lang=js&"
export * from "./TableInfoMonthly.vue?vue&type=script&lang=js&"
import style0 from "./TableInfoMonthly.vue?vue&type=style&index=0&id=381e1d6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381e1d6f",
  null
  
)

export default component.exports